import React from 'react';
import type { QueueStage } from '../data/mockData';
const toneByStage: Record<string, string> = {
  New: 'bg-brand-soft text-brand-dark',
  Contacting: 'bg-navy-soft text-navy',
  Engaged: 'bg-teal-soft text-teal',
  'App Started': 'bg-success-soft text-success',
  'App Intake · App Received': 'bg-success-soft text-success',
  'App Intake · Credit & Pricing': 'bg-success-soft text-success',
  'Clear to Close': 'bg-success-soft text-success'
};
type StageBadgeProps = {
  stage: QueueStage;
  suffix?: string;
};
export function StageBadge({
  stage,
  suffix
}: StageBadgeProps) {
  return <span className={['inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium', toneByStage[stage] ?? 'bg-gray-100 text-gray-700'].join(' ')} data-id="element-674" data-mp="120irpwi76rbb">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-675" data-mp="2df5t3pgt7lg5" />
      {suffix ? `${stage} · ${suffix}` : stage}
    </span>;
}